"use client";

import { Box } from "@chakra-ui/react";
import { Text } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";
import { PublicEntrance } from "@/components/shared/motion";

export interface PublicPageHeroContent {
  label: string;
  title: string;
  description: string;
}

interface PublicPageHeroProps extends PublicPageHeroContent {
  mb?: number | { base?: number; md?: number };
  variant?: "default" | "compact";
}

export function PublicPageHero({
  label,
  title,
  description,
  mb = 0,
  variant = "default",
}: PublicPageHeroProps) {
  const theme = useThemeTokens();
  const isCompact = variant === "compact";

  return (
    <PublicEntrance variant="hero" as="section">
      <Box mb={mb}>
        <Text
          fontSize="xs"
          textTransform="uppercase"
          letterSpacing="0.18em"
          color={theme.text.tertiary}
          mb={isCompact ? 1.5 : 2}
        >
          {label}
        </Text>
        <Text
          as="h1"
          fontSize={isCompact ? { base: "xl", md: "2xl" } : { base: "2xl", md: "3xl" }}
          fontWeight="600"
          letterSpacing="-0.03em"
          color={theme.text.primary}
          mb={isCompact ? 2 : 3}
          lineHeight="1.2"
        >
          {title}
        </Text>
        {description ? (
          <Text
            fontSize={isCompact ? "sm" : "md"}
            color={theme.text.secondary}
            lineHeight="1.5"
            noOfLines={isCompact ? 2 : undefined}
          >
            {description}
          </Text>
        ) : null}
      </Box>
    </PublicEntrance>
  );
}
